import { AUTH_LOGOUT } from '@/store/auth';
import Vue from 'vue';
import Http from '@/Http';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';

const state = {
  status: '',
  profile: {}
};

const getters = {
  getProfile: (state:any) => state.profile,
  isProfileLoaded: (state:any) => !!state.profile.name
};

const actions = {
  [USER_REQUEST]: ({ commit, dispatch }:any) => {
    commit(USER_REQUEST);
    (new Http()).request({ url: 'user' })
      .then((resp:any) => {
        commit(USER_SUCCESS, resp.data.data);
      })
      .catch(() => {
        commit(USER_ERROR);
        // if resp is unauthorized, logout, to
        dispatch(AUTH_LOGOUT);
      });
  }
};

const mutations = {
  [USER_REQUEST]: (state:any) => {
    state.status = 'loading';
  },
  [USER_SUCCESS]: (state:any, resp:any) => {
    state.status = 'success';
    Vue.set(state, 'profile', resp);
  },
  [USER_ERROR]: (state:any) => {
    state.status = 'error';
  },
  [AUTH_LOGOUT]: (state:any) => {
    state.profile = {};
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
